import React from 'react';
import { Footer } from './Footer';

interface StaticPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function StaticPageLayout({ children, className = '' }: StaticPageLayoutProps) {
  return (
    <div className={`min-h-screen flex flex-col bg-white ${className}`}>
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
}
